import { render, staticRenderFns } from "./PgFormDelete.vue?vue&type=template&id=5b053211&"
import script from "./PgFormDelete.vue?vue&type=script&lang=js&"
export * from "./PgFormDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PgFormDelete.vue"
export default component.exports